var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryblue1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44847 5.36425L7.34251 6.33855L6.32183 9.89408L7.73542 9.46031L8.72639 10.4965L9.74707 6.93944L13.642 7.9145C13.9214 7.9846 14.089 8.25531 14.014 8.51621L12.0154 15.4796C11.9403 15.7405 11.6504 15.8979 11.3701 15.8278L1.17748 13.2784C0.898085 13.2082 0.730447 12.9376 0.805538 12.6767L2.80408 5.7124C2.8783 5.45151 3.16908 5.29497 3.44847 5.36425Z",
    fill: "#1B4497"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1329 19.6727C13.1329 17.8318 14.7368 16.3341 16.7083 16.3341C18.6789 16.3341 20.2827 17.8318 20.2827 19.6727C20.2827 21.5137 18.6789 23.0114 16.7074 23.0114C14.7368 23.0114 13.1329 21.5137 13.1329 19.6727ZM15.389 19.6727C15.389 20.3519 15.9801 20.9046 16.7083 20.9046C17.4356 20.9046 18.0267 20.3519 18.0267 19.6727C18.0267 18.9936 17.4356 18.4408 16.7083 18.4408C15.9801 18.4416 15.389 18.9936 15.389 19.6727Z",
    fill: "#1B4497"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31347 15.8457L12.5254 20.0665C12.5114 19.9377 12.5044 19.8065 12.5044 19.6735C12.5044 18.4343 13.1234 17.3295 14.0873 16.6097L15.101 13.0101L18.3114 13.8417L17.8303 15.8954C18.3394 16.0275 18.8082 16.2468 19.2203 16.5346L20.7876 9.84107L17.8547 5.16061L18.5899 3.1009L19.3252 1.0412C19.6928 0.69792 19.3252 0.0113525 18.9576 0.0113525C18.2223 0.0113525 17.4871 0.354636 17.2969 1.04121L15.4834 6.19046L12.4371 16.9407L2.702 14.4891C2.29863 14.3879 1.88827 14.6113 1.78087 14.9856C1.67348 15.3598 1.91184 15.7454 2.31347 15.8457ZM15.4834 11.651L16.7975 6.98667L19.1775 10.1427L18.6345 12.4655L15.4834 11.651Z",
    fill: "#1B4497"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryblue1);
export default __webpack_public_path__ + "static/media/inventoryblue1.04a3a7b0347352f0f8efd18ae5ae2980.svg";
export { ForwardRef as ReactComponent };